export { default } from './Avatar';

export * from './Avatar';
